export default "__VITE_ASSET__CCGgi5dI__"